import { ApmBase } from "@elastic/apm-rum";
import jwtDecode from "jwt-decode";

import { getUserData, tokenType } from "./Login";
import { fetchTenantName } from "../provider/pilegateprovider";

export const monitor = (
  apm: ApmBase | undefined,
  eventName: string,
  action?: () => void,
  labels?: Labels
) => {
  if (apm) {
    const transaction = apm.startTransaction(eventName, "custom");
    if (labels && transaction) transaction.addLabels(labels);

    if (action) {
      return Promise.resolve(action()).finally(() => {
        if (transaction) transaction.end();
      });
    } else {
      setTimeout(() => {
        if (transaction) transaction.end();
      }, 5);
    }
  } else {
    if (action) {
      return Promise.resolve(action());
    }
  }
};

export const setApmUserContext = (
  apm: ApmBase,
  tokens: tokenType,
  userContext?: {
    id?: string;
    username?: string;
    email?: string;
  }
) => {
  const userData = getUserData(tokens);
  if (userContext) {
    apm.setUserContext(userContext);
  } else {
    const context: UserObject = {
      username: userData.username,
    };
    if (userData.usermail) {
      context.email = userData.usermail;
    }
    apm.setUserContext(context);
  }

  try {
    const decoded_token: any = jwtDecode(tokens.access_token);
    let labels = {
      tenant_name: "unknown",
      userpool_id: userData.userpool_id,
      sessionid: decoded_token.jti,
      client_id: userData.client_id,
      user_groups: userData.usergroups.join(","),
      version: process.env.npm_package_version || "unknown",
    };
    if (userData?.isMigrated === true) {
      // only fetch tenant name for migrated non-api users
      fetchTenantName(userData.userpool_id, tokens.access_token)
        .then((data) => {
          if (data) {
            labels = { ...labels, tenant_name: data.name };
          }
        })
        .finally(() => {
          apm.addLabels(labels);
        });
    } else {
      labels = { ...labels, tenant_name: userData.tenant };
      apm.addLabels(labels);
    }
  } catch {
    console.error("There was an invalid token specified.");
  }
};
